import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { ICompanyUsersProps } from "../../../../interfaces/company-user/ICompanyUsers";
import Error from "../../../../shared/error";
import { useCallback, useState } from "react";
import {
  useEditCompanyUserMutation,
  useGetCompanyUsersRolesQuery,
  usePostCompanyUserMutation,
} from "../../../../store/company-users/companyUsersApi";
import Input from "../../../../shared/input";
import Select from "../../../../shared/select";
import Button from "../../../../shared/button";

const CreateCompanyUser = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ICompanyUsersProps>();

  const {data: userRoles} = useGetCompanyUsersRolesQuery()
  const [postCompanyUser] = usePostCompanyUserMutation();
  const [editCompanyUser] = useEditCompanyUserMutation();

  const [createError, setCreateError] = useState<string | null>();
  const { id } = useParams();
  const onSubmit = async (data: ICompanyUsersProps) => {
    try {
      if (id) {
        await editCompanyUser({ ...data, id }).unwrap();
      } else {
        await postCompanyUser(data).unwrap();
      }
      reset();
      navigate("/users");
      setCreateError(null);
    } catch (error) {
      setCreateError(`${error}`);
    }
  };

  const handleGoBack = useCallback(() => navigate(-1), [navigate]);

  const formatRoles = userRoles?.data.map(role => (
	{
		label: role.displayName,
		value: role.name
	}
  )) || [];

  return (
    <div>
      <div className={"flex flex-row items-center justify-between"}>
        <div className="flex flex-row items-center">
          <div
            data-qa={"back-button"}
            onClick={handleGoBack}
            className="md:-ml-2 xl:-ml-12 md:mr-2 xl:mr-10"
          >
            <img
              alt="go back"
              src={"/assets/shared/go-back.svg"}
              className={"w-[18px] object-contain cursor-pointer"}
            />
          </div>
          <p className="page-title">{id ? "Edit User" : "Create User"}</p>
        </div>
      </div>
      <div className="mt-5 mb-2">
        {createError && <Error text={createError} />}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-wrap -mx-2"
        >
          <div className="w-full md:w-6/12 mb-5 px-2">
            <Input
              label="Name"
              dataQa={"name"}
              register={register("name", {
                required: {
                  message: "Name is required",
                  value: true,
                },
                validate: (value: string) =>
                  !!value.trim() || "Name is required",
              })}
              error={errors.name?.message}
            />
          </div>
          <div className="w-full md:w-6/12 mb-5 px-2">
            <Input
              label="Email"
              dataQa={"email"}
              register={register("email", {
                required: {
                  message: "Email is required",
                  value: true,
                },
                validate: (value: string) =>
                  !!value.trim() || "Email is required",
              })}
              error={errors.email?.message}
            />
          </div>
          <div className="w-full md:w-6/12 mb-5 px-2">
            <Input
              label="Phone number"
              dataQa={"phone-number"}
              register={register("phone", {
                required: {
                  message: "Phone number is required",
                  value: true,
                },
                validate: (value: string) =>
                  !!value.trim() || "Phone number is required",
              })}
              error={errors.phone?.message}
            />
          </div>
          <div className="w-full md:w-6/12 mb-5 px-2">
            <label
              className={`block text-primary-light font-normal text-base mb-1`}
            >
              Role
            </label>
            <Select
              register={register("role", {
                required: {
                  message: "Role is required",
                  value: true,
                },
              })}
              placeholder="Select a role"
              options={[...formatRoles]}
              error={errors.phone?.message}
            ></Select>
          </div>
		  <Button label={id ? "Edit" : "Create"} type='submit' />
        </form>
      </div>
    </div>
  );
};

export default CreateCompanyUser;
